import React from 'react'

const colorMap = {
  image: '#3699FF',
  pdf: '#F64E60',
  word: '#3699FF',
  excel: '#1BC5BD',
  video: '#FFA800',
  archive: '#8950FC',
  cad: '#B5B5C3',
  generic: '#B5B5C3',
}

const getFileIconType = (name, contentType) => {
  const nameParts = name ? name.split('.') : []
  const ext = nameParts.length > 1 ? nameParts[nameParts.length - 1].toLowerCase() : ''

  if ((contentType && contentType.startsWith('image/')) || ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext))
    return 'image'
  if (contentType === 'application/pdf' || ext === 'pdf') return 'pdf'
  if (['doc', 'docx'].includes(ext)) return 'word'
  if (['xls', 'xlsx'].includes(ext)) return 'excel'
  if ((contentType && contentType.startsWith('video/')) || ['mp4', 'mov', 'avi', 'mkv'].includes(ext)) return 'video'
  if (['zip', 'rar', '7z'].includes(ext)) return 'archive'
  if (['dwg', 'kmz', 'kml', 'ncz'].includes(ext)) return 'cad'
  return 'generic'
}

export const FileTypeIcon = ({name, contentType}) => {
  const type = getFileIconType(name, contentType)
  const color = colorMap[type] || colorMap.generic

  return (
    <span className='svg-icon svg-icon-2x me-4' style={{color}}>
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          opacity='0.3'
          d='M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22Z'
          fill='currentColor'
        />
        <path d='M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z' fill='currentColor' />
      </svg>
    </span>
  )
}
